
import { Card, ViewHeader } from '@enkla-gui'
import React, { useState, useMemo } from 'react'

const frontend = require('./frontend')

function LicenseGroup({ license, packages, defaultOpen }) {
  const [open, setOpen] = useState(defaultOpen || false)
  return (
    <div class='license-group'>
      <div class='license-group-header' onClick={() => setOpen(!open)}>
        <div class='license-group-info'>
          <span class='license-group-name'>{license}</span>
          <span class='license-group-count'>{packages.length} paket</span>
        </div>
        <i class={`fas fa-chevron-${open ? 'up' : 'down'} license-group-arrow`} />
      </div>
      {open && (
        <div class='license-group-packages'>
          {packages.map(([name, info]) => (
            <a key={name} class='license-package' href={info.repository} target='_blank' rel='noreferrer'>
              <span class='license-package-name'>{name}</span>
              <i class='fas fa-external-link-alt license-package-link' />
            </a>
          ))}
        </div>
      )}
    </div>
  )
}


export default function About() {
  const [searchFilter, setSearchFilter] = useState('')

  const licenseGroups = useMemo(() => {
    const groups = {}
    for (const [name, info] of Object.entries(frontend)) {
      if (searchFilter && !name.toLowerCase().includes(searchFilter.toLowerCase())) continue
      const license = info.licenses || 'Unknown'
      if (!groups[license]) groups[license] = []
      groups[license].push([name, info])
    }
    return Object.entries(groups).sort((a, b) => b[1].length - a[1].length)
  }, [searchFilter])

  return (
    <>
      <ViewHeader icon='fa-info-circle' title='Hjälp' subtitle='Om oss' badges={[
        { bg: 'primary', text: 'v1.40.0-RC1', icon: 'fas fa-code' },
      ]}
      />

      <div class='about-hero'>
        <Card>
          <div class='about-hero-content'>
            <div class='about-hero-icon'>
              <i class='fas fa-building' />
            </div>
            <div class='about-hero-text'>
              <h2>Enkla Fastigheter</h2>
              <p>
                Välkommen till vårt molnbaserade fastighetssystem som samlar all din hyresadministration
                på ett och samma ställe. Hantera fastigheter, hyresgäster, hyresavier, betalningar och avtal
                &ndash; allt i ett användarvänligt gränssnitt.
              </p>
              <p>
                Systemet automatiserar rutinmässiga uppgifter så att du får mer tid till det som
                är viktigt för din fastighetsverksamhet.
              </p>
            </div>
          </div>
        </Card>
      </div>

      <div class='about-stats'>
        <a href='/#!/help/contact' class='about-stat-card'>
          <div class='about-stat-icon about-stat-blue'>
            <i class='fas fa-envelope' />
          </div>
          <div class='about-stat-text'>
            <span class='about-stat-value'>Kontakta oss</span>
            <span class='about-stat-label'>kontakt@enklafastigheter.se</span>
          </div>
        </a>
        <a href='/#!/help/faq' class='about-stat-card'>
          <div class='about-stat-icon about-stat-teal'>
            <i class='fas fa-question-circle' />
          </div>
          <div class='about-stat-text'>
            <span class='about-stat-value'>Vanliga frågor</span>
            <span class='about-stat-label'>Svar på vanliga frågor</span>
          </div>
        </a>
        <div class='about-stat-card'>
          <div class='about-stat-icon about-stat-purple'>
            <i class='fas fa-briefcase' />
          </div>
          <div class='about-stat-text'>
            <span class='about-stat-value'>Enkla XYZ AB</span>
            <span class='about-stat-label'>Org.nr 559390-9574 &middot; Säte Linköping</span>
          </div>
        </div>
      </div>
      <Card
        title='Tredjepartslicenser'
        collapsed
        icon='fa fa-fw fa-scroll'>
        <p class='about-licenses-intro'>
          Enkla Fastigheter använder tredjepartsbibliotek och verktyg med öppen källkod i bakgrunden.
          Detta påverkar inte dig som användare, men vi är skyldiga att visa information om licenserna
          för dessa komponenter.
        </p>
        <div class='about-licenses-search'>
          <i class='fas fa-search' />
          <input
            type='text'
            placeholder='Sök bland paket...'
            value={searchFilter}
            onChange={e => setSearchFilter(e.target.value)}
          />
        </div>
        <div class='about-licenses-list'>
          {licenseGroups.map(([license, packages]) => (
            <LicenseGroup
              key={license}
              license={license}
              packages={packages}
              defaultOpen={licenseGroups.length === 1}
            />
          ))}
          {licenseGroups.length === 0 && (
            <p class='about-licenses-empty'>Inga paket matchar din sökning.</p>
          )}
        </div>
      </Card>
    </>
  )
}
